"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (function (obj, func) {
    var result = {};
    for (var key in obj) {
        if (obj.hasOwnProperty(key)) {
            result[key] = func(obj[key], key);
        }
    }
    return result;
});
//# sourceMappingURL=mapValues.js.map